export const blockIconsHomeDetectionAndZoneNew = (
	<span className='material-symbols-outlined'>detection_and_zone</span>
);
